export enum SocialMedia {
	Facebook = "Facebook",
	Instagram = "Instagram",
	LinkedIn = "LinkedIn",
	Twitter = "Twitter",
	TikTok = "TikTok",
	Website = "Website",
}
export type SocialMediaKeys = keyof typeof SocialMedia;